import React from 'react';

import { Group, Stack, Text } from '@mantine/core';
import { IconCalendarPause } from '@tabler/icons-react';
import { CurrentPackage } from 'types/generated';

interface CurrentPackagesTableCellProps {
  currentPackages: CurrentPackage[];
}

const CurrentPackagesTableCell = ({
  currentPackages,
}: CurrentPackagesTableCellProps): React.ReactElement => {
  const activePackages = currentPackages.filter(p => p.state === 'ACTIVE');
  const holdPackages = currentPackages.filter(p => p.state === 'HOLD');
  const activeFull = activePackages.map(p => p.name).join(', ');
  const holdFull = holdPackages.map(p => p.name).join(', ');
  const activeText = activeFull.length > 60 ? `${activeFull.slice(0, 60)}...` : activeFull;
  const holdText = holdFull.length > 60 ? `${holdFull.slice(0, 60)}...` : holdFull;

  return (
    <Stack spacing={0}>
      {activeText && <Text>{activeText}</Text>}
      {holdText && (
        <Group spacing={4} noWrap>
          <IconCalendarPause size={14} color='gray' />
          <Text color='dimmed'>{holdText}</Text>
        </Group>
      )}
    </Stack>
  );
};

export default CurrentPackagesTableCell;
